import React, { useEffect, useRef, useState } from "react";
import grow2 from "../../images/LandingPageImage/Vector (1).png";
import grow3 from "../../images/LandingPageImage/Vector (2).png";
import grow1 from "../../images/LandingPageImage/Vector (3).png";
import "./LandingPage.css";
import"./Testimonial.css"

const CounterNumber = ({ end, suffix = "", duration = 1600, start }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let startTime = null;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;

      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.floor(easedProgress * end);

      setCount(currentValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(animate);
  }, [end, duration, start]);

  return (
    <>
      {count.toLocaleString()}
      {suffix}
    </>
  );
};

const RestaurantSuccess = () => {
  const statsRef = useRef(null);
  const testimonialRef = useRef(null);

  const [startCounter, setStartCounter] = useState(false);
  const [showTestimonials, setShowTestimonials] = useState(false);

  useEffect(() => {
    const currentStats = statsRef.current;

    if (!currentStats) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounter(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.35 }
    );

    observer.observe(currentStats);

    return () => {
      if (currentStats) observer.unobserve(currentStats);
    };
  }, []);

  useEffect(() => {
    const currentTestimonials = testimonialRef.current;

    if (!currentTestimonials) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowTestimonials(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(currentTestimonials);

    return () => {
      if (currentTestimonials) observer.unobserve(currentTestimonials);
    };
  }, []);

  return (
    <>
      {/* Green Stats Section */}
      <div className="stats-wrap" ref={statsRef}>
        <div className="stats-container">
          <div className="stats-left">
            <h2>Helping Restaurants Grow Everyday</h2>
          </div>

          <div className="stats-right">
            <div className="stats-box">
              <div className="stats-icon">
                <img src={grow1} alt="Restaurants" />
              </div>
              <h3>
                <CounterNumber end={500} suffix="+" start={startCounter} />
              </h3>
              <p>Local & Popular Food Outlets</p>
            </div>

            <div className="divider"></div>

            <div className="stats-box">
              <div className="stats-icon">
                <img src={grow2} alt="Orders" />
              </div>
              <h3>
                <CounterNumber end={25000} suffix="+" start={startCounter} />
              </h3>
              <p>Meals Delivered Daily</p>
            </div>

            <div className="divider"></div>

            <div className="stats-box">
              <div className="stats-icon">
                <img src={grow3} alt="Delivered" />
              </div>
              <h3>
                <CounterNumber end={50} suffix="k+" start={startCounter} />
              </h3>
              <p>Happy Customers Served</p>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial Section - Outside Green Section */}
      <section
        className={`anlook-testimonials ${
          showTestimonials ? "testimonial-visible" : ""
        }`}
        ref={testimonialRef}
      >
        <div className="testimonial-header">
          <span className="testimonial-badge">Restaurant Testimonials</span>

          <h3>Restaurants are growing with Anlook</h3>

          <p>
            Anlook helps restaurants manage online orders, reduce dependency on
            high-commission platforms, and keep better control over profits.
          </p>
        </div>

        <div className="testimonial-cards">
          <div className="anlook-testimonial-card">
            <div className="quote-mark">“</div>

            <p>
              Anlook made our daily order handling much smoother. Menu updates,
              order tracking, and customer management are now easier from one
              platform.
            </p>

            <div className="testimonial-profile">
              <div className="profile-avatar">R</div>
              <div>
                <h5>Restaurant Owner</h5>
                <span>Local Food Outlet</span>
              </div>
            </div>
          </div>

          <div className="anlook-testimonial-card active-card">
            <div className="quote-mark">“</div>

            <p>
              The biggest benefit is control. We can manage our business without
              hidden commissions and understand our orders better.
            </p>

            <div className="testimonial-profile">
              <div className="profile-avatar">A</div>
              <div>
                <h5>Anlook Partner</h5>
                <span>Quick Service Restaurant</span>
              </div>
            </div>
          </div>

          <div className="anlook-testimonial-card">
            <div className="quote-mark">“</div>

            <p>
              Earlier online order management was confusing. With Anlook, our
              staff can manage everything faster and serve customers better.
            </p>

            <div className="testimonial-profile">
              <div className="profile-avatar">F</div>
              <div>
                <h5>Food Business Owner</h5>
                <span>Popular Restaurant</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RestaurantSuccess;